import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { isLogin } from '../../functions/Auth';
import Header from '../Headers/Header';
import UserHeader from '../Headers/UserHeader';
import { NavLink } from 'react-router-dom';
import LocationOffIcon from '@material-ui/icons/LocationOff';

//Start Css Code ....
const useStyles = makeStyles((theme) => ({
    pageNotFound: {
        position: 'absolute',        
        textAlign: 'center',
        border: '1px solid #24618E',
        borderRadius: '5px',        
        '@media only screen and (max-width: 3500px)': {
            width: '580px',
            padding: '20px',
            left: '50px',
            top: '100px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '1000px',
            padding: '30px',
            left: '75px',
            top: '150px',
        },
    },
    pageNotFoundText: {
        color: '#24618E',
        fontWeight: '600',
        textAlign: 'left',
        marginTop: '0px',
        marginBottom: '10px',        
        '@media only screen and (max-width: 3500px)': {
            fontSize: '20pt'
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '30pt'
        },
    },
    pageNoterror: {
        marginBottom: '0px',
        marginTop: '-20px',
        fontWeight: '800',
        color: '#00A75D',       
        textAlign: 'left',        
        '@media only screen and (max-width: 3500px)': {
            fontSize: '120pt',
            lineHeight: '50pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '180pt',
            lineHeight: '75pt',
        },
        '& svg': {            
            position: 'relative',
            top: '20px',
            '@media only screen and (max-width: 3500px)': {
                fontSize: '120pt',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '180pt',                
            },
        },
    },
    homeLink: {        
        marginTop: '25px',
        textTransform: 'capitalize',
        '@media only screen and (max-width: 3500px)': {
            lineHeight: '30pt',
        },
        '@media only screen and (min-width: 3501px)': {
            lineHeight: '50pt',                
        },
        '& a': {
            background: '#24618E',            
            color: '#fff',
            textDecoration: 'none',
            cursor: 'pointer',
            borderRadius: '5px',
            fontWeight: '500',
            '@media only screen and (max-width: 3500px)': {
                padding: '10px 25px',
            },
            '@media only screen and (min-width: 3501px)': {
                padding: '15px 30px',                
            },
        }
    },
    simpleText: {
        textAlign: 'left',
        margin: '10px 0'
    }
}));
//End Css Code ....


//Start PageNotFound component Code ....
const PageNotFound = () => {
    const classes = useStyles();
    return (
        <React.Fragment>

            {isLogin() ? <UserHeader /> : <Header />}

            <div className={classes.pageNotFound}>
                <p className={classes.pageNoterror}><span><LocationOffIcon /></span>404</p>
                <p className={classes.pageNotFoundText}>The page you are looking for does not exist.</p>
                <p className={classes.simpleText}>The link that brought you here may have contained a typo, the page you are looking for may have moved, or DataPoint may be experiencing a temporary case of the hiccups.</p>
                <p className={classes.simpleText}>Let's head back to the map and see if we can point out the right data you need.</p>
                <p className={classes.homeLink}><NavLink to='/'>Back to DataPoint Home</NavLink></p>
            </div>

        </React.Fragment>
    );
}
export default PageNotFound;
//End PageNotFound component Code ....